"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Accounting
__exportStar(require("./accountings/accouting"), exports);
__exportStar(require("./accountings/delete-many"), exports);
__exportStar(require("./accountings/export-transfer-order"), exports);
__exportStar(require("./accountings/get-by-id-with-slots"), exports);
__exportStar(require("./accountings/get-list"), exports);
__exportStar(require("./accountings/import-doctolib-csv"), exports);
__exportStar(require("./accountings/import-doctolib-csv-dazz"), exports);
__exportStar(require("./accountings/set-paid"), exports);
// Agenda slot reservations
__exportStar(require("./agenda-slot-reservations/confirm-agenda-slot-reservation"), exports);
__exportStar(require("./agenda-slot-reservations/confirm-agenda-slot-reservation-many"), exports);
__exportStar(require("./agenda-slot-reservations/decline-agenda-slot-reservation"), exports);
__exportStar(require("./agenda-slot-reservations/decline-agenda-slot-reservation-many"), exports);
// Agenda slots
__exportStar(require("./agenda-slots/agenda-slot"), exports);
__exportStar(require("./agenda-slots/agenda-slot-import-doctolib-csv"), exports);
__exportStar(require("./agenda-slots/agenda-slot-reservation"), exports);
__exportStar(require("./agenda-slots/agenda-slot-set-accounting-information"), exports);
__exportStar(require("./agenda-slots/book-agenda-slot"), exports);
__exportStar(require("./agenda-slots/create-slot"), exports);
__exportStar(require("./agenda-slots/create-slot-bulk"), exports);
__exportStar(require("./agenda-slots/delete-agenda-slot"), exports);
__exportStar(require("./agenda-slots/delete-agenda-slot-occurence"), exports);
__exportStar(require("./agenda-slots/get-agenda-slot-available-list"), exports);
__exportStar(require("./agenda-slots/get-agenda-slot-booked-stats-list"), exports);
__exportStar(require("./agenda-slots/get-agenda-slot-by-id"), exports);
__exportStar(require("./agenda-slots/get-agenda-slot-list"), exports);
__exportStar(require("./agenda-slots/get-agenda-slot-paginate-list"), exports);
__exportStar(require("./agenda-slots/get-move-slot-options"), exports);
__exportStar(require("./agenda-slots/get-slot-assistant-day-boundary"), exports);
__exportStar(require("./agenda-slots/get-substitute-earnings-stats"), exports);
__exportStar(require("./agenda-slots/move-agenda-slot"), exports);
__exportStar(require("./agenda-slots/rrule"), exports);
__exportStar(require("./agenda-slots/stop-recurrence"), exports);
__exportStar(require("./agenda-slots/update-agenda-slot-assistant-mode"), exports);
// Attending Accountings
__exportStar(require("./attending-accountings/delete"), exports);
__exportStar(require("./attending-accountings/get-list"), exports);
__exportStar(require("./attending-accountings/set-paid-flags"), exports);
__exportStar(require("./auth/forgot-password"), exports);
// Auth
__exportStar(require("./auth/login"), exports);
__exportStar(require("./auth/logout"), exports);
__exportStar(require("./auth/reset-password"), exports);
__exportStar(require("./auth/sign-up-doctor-attending"), exports);
__exportStar(require("./auth/sign-up-doctor-substitute"), exports);
// Capabilities (authorization)
__exportStar(require("./capabilities"), exports);
__exportStar(require("./doctor-attendings/activate-doctor-attending"), exports);
__exportStar(require("./doctor-attendings/create-doctor-attending"), exports);
__exportStar(require("./doctor-attendings/create-doctor-attending-by-doctor"), exports);
__exportStar(require("./doctor-attendings/delete-doctor-attending"), exports);
// Doctor attendings
__exportStar(require("./doctor-attendings/doctor-attending"), exports);
__exportStar(require("./doctor-attendings/generate-accounting-doctolib-csv"), exports);
__exportStar(require("./doctor-attendings/get-attending-leave"), exports);
__exportStar(require("./doctor-attendings/get-doctor-attending"), exports);
__exportStar(require("./doctor-attendings/get-doctor-attending-list"), exports);
__exportStar(require("./doctor-attendings/get-doctor-attending-offices"), exports);
__exportStar(require("./doctor-attendings/get-doctor-attending-with-accountings-list"), exports);
__exportStar(require("./doctor-attendings/get-doctor-attending-with-invitations-list"), exports);
__exportStar(require("./doctor-attendings/remove-doctor-attending-office"), exports);
__exportStar(require("./doctor-attendings/sync-attending-leave"), exports);
__exportStar(require("./doctor-attendings/update-doctor-attending"), exports);
__exportStar(require("./doctor-substitutes/add-doctor-substitute-contract"), exports);
__exportStar(require("./doctor-substitutes/bulk-create-contracts"), exports);
__exportStar(require("./doctor-substitutes/bulk-remind-contracts"), exports);
__exportStar(require("./doctor-substitutes/delete-doctor-subtitute"), exports);
__exportStar(require("./doctor-substitutes/delete-doctor-subtitute-contract"), exports);
// Doctor substitutes
__exportStar(require("./doctor-substitutes/doctor-substitute"), exports);
__exportStar(require("./doctor-substitutes/doctor-substitute-document"), exports);
__exportStar(require("./doctor-substitutes/get-doctor-substitute"), exports);
__exportStar(require("./doctor-substitutes/get-doctor-substitute-contract-details"), exports);
__exportStar(require("./doctor-substitutes/get-doctor-substitute-contract-exists"), exports);
__exportStar(require("./doctor-substitutes/get-doctor-substitute-contracts-list"), exports);
__exportStar(require("./doctor-substitutes/get-doctor-substitute-list"), exports);
__exportStar(require("./doctor-substitutes/get-doctor-substitute-with-invitations-list"), exports);
__exportStar(require("./doctor-substitutes/get-substitute-availability"), exports);
__exportStar(require("./doctor-substitutes/preview-doctor-substitute-contracts"), exports);
__exportStar(require("./doctor-substitutes/sign-doctor-substitute-contract"), exports);
__exportStar(require("./doctor-substitutes/sync-substitute-availability"), exports);
__exportStar(require("./doctor-substitutes/update-doctor-subtitute"), exports);
// Doctors
__exportStar(require("./doctors/get-doctor-list"), exports);
__exportStar(require("./global/address.schema"), exports);
__exportStar(require("./global/api"), exports);
__exportStar(require("./global/bank-details.schema"), exports);
__exportStar(require("./global/event.schema"), exports);
__exportStar(require("./global/french-department"), exports);
__exportStar(require("./global/password.schema"), exports);
__exportStar(require("./global/profile.schema"), exports);
__exportStar(require("./global/social-security-number.schema"), exports);
__exportStar(require("./global/success-response.schema"), exports);
__exportStar(require("./invitations/attach-slot"), exports);
__exportStar(require("./invitations/create-invitation"), exports);
__exportStar(require("./invitations/delete-invitation"), exports);
__exportStar(require("./invitations/get-invitation-exists"), exports);
// Invitations
__exportStar(require("./invitations/invitation"), exports);
__exportStar(require("./invitations/pending-invitation-for-office"), exports);
__exportStar(require("./invitations/refresh-invitation"), exports);
// Medical assistants
__exportStar(require("./medical-assistants"), exports);
__exportStar(require("./offices/assign-office-csm"), exports);
__exportStar(require("./offices/create-office"), exports);
__exportStar(require("./offices/create-office-planning"), exports);
__exportStar(require("./offices/delete-office"), exports);
__exportStar(require("./offices/doctolib-planning-sync"), exports);
__exportStar(require("./offices/generate-occupation-report"), exports);
// Offices
__exportStar(require("./offices/get-office"), exports);
__exportStar(require("./offices/get-office-planning"), exports);
__exportStar(require("./offices/get-offices-activity"), exports);
__exportStar(require("./offices/get-offices-agendas-list"), exports);
__exportStar(require("./offices/get-offices-list"), exports);
__exportStar(require("./offices/get-offices-stats"), exports);
__exportStar(require("./offices/office"), exports);
__exportStar(require("./offices/send-available-slots-reminder"), exports);
__exportStar(require("./offices/send-occupation-report-reminder"), exports);
__exportStar(require("./offices/update-office"), exports);
__exportStar(require("./offices/update-office-site"), exports);
__exportStar(require("./referrals"), exports);
// Shared documents
__exportStar(require("./shared-documents"), exports);
__exportStar(require("./sites/create-site"), exports);
// Sites
__exportStar(require("./sites/get-sites-list"), exports);
// Substitute Physical Office Access
__exportStar(require("./substitute-physical-office-access"), exports);
__exportStar(require("./users/get-me"), exports);
__exportStar(require("./users/list-csm-users"), exports);
__exportStar(require("./users/update-user-profile"), exports);
// Users
__exportStar(require("./users/user"), exports);
__exportStar(require("./work-schedule-slots/convert-work-schedule-slot"), exports);
__exportStar(require("./work-schedule-slots/create-work-schedule-slot"), exports);
__exportStar(require("./work-schedule-slots/create-work-schedule-slot-bulk"), exports);
__exportStar(require("./work-schedule-slots/delete-by-id"), exports);
__exportStar(require("./work-schedule-slots/delete-occurence"), exports);
__exportStar(require("./work-schedule-slots/get-by-id"), exports);
__exportStar(require("./work-schedule-slots/get-list"), exports);
__exportStar(require("./work-schedule-slots/stop-recurrence"), exports);
// Work Schedule slots
__exportStar(require("./work-schedule-slots/work-schedule-slot"), exports);
